<template>
  <div>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <v-container fluid class="px-0">
        <div class="px-md-10">
          <h4 class="primary--text mt-0" style="position: relative">
            {{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.selectPayment') }}
          </h4>
          <div class="mt-10" style="display: flex; flex-direction: column;">
            <div>
              <CardRegistrationButton :resumen="resumen" @changeStep="$emit('changeStep', $event)" />
            </div>
            <div class="top-spaced">
              <RedsysButton :resumen="resumen" @changeStep="$emit('changeStep', $event)"></RedsysButton>             
            </div>
            <div class="top-spaced">
              <FlywireButton :resumen="resumen" @changeStep="$emit('changeStep', $event)"></FlywireButton>
            </div>
            <div class="top-spaced">
              <PayPalButton :resumen="resumen" @changeStep="$emit('changeStep', $event)"></PayPalButton>
            </div>
          </div>
        </div>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import PayPalButton from '../Components/PayPalButton/PayPalButton';
import RedsysButton from '../Components/RedsysButton/RedsysButton';
import FlywireButton from '../Components/FlywireButton/FlywireButton.vue';
import CardRegistrationButton from '../Components/CardRegistrationButton/CardRegistrationButton.vue';
export default {
  name: 'PaymentsSelectionView',
  props: {
    resumen: Object
  },
  components: {
    PayPalButton,
    RedsysButton,
    FlywireButton,
    CardRegistrationButton
  },
};
</script>

<style scoped lang="sass">
  .promotions
    float: right
    font-size: 11px
    line-height: 24px
    vertical-align: middle
    font-weight: bold
  .top-spaced
    margin-top: 10px
</style>
